module.exports = __webpack_public_path__ + "public/images/slider/speaker-5.f1490c872f436425f008bc1b8269e667.jpg";